import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { FaCheck, FaTimes, FaTrash, FaUndo } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import TextInputModal from "../../common/TextInputModal";
import {
  updateSuppliersInvoiceItem,
  deleteSupplierInvoiceItem,
  restoreSupplierInvoiceItem,
} from "../../../redux/Actions/suppliersInvoicesAction";

function TableItem({ id, item, index }) {
  useEffect(() => {
    setInputValue(item.item_code_rivile);
    setAgataPrice(item.agata_price);
    setAgataCode(item.agata_code);
    setUnitPrice(item.unit_price);
  }, [item]);

  const [edit, setEdit] = useState(false);
  const [inputValue, setInputValue] = useState(item.item_code_rivile);
  const [agataPrice, setAgataPrice] = useState(item.agata_price);
  const [agataCode, setAgataCode] = useState(item.agata_code);
  const [unitPrice, setUnitPrice] = useState(item.unit_price);

  const dispatch = useDispatch();
  const isDeleted = !!item.deleted_at;
  const failedMatch = item.failed_match;

  const onEdit = () => {
    if (isDeleted) return;
    setEdit(true);
  };

  const onSubmit = () => {
    dispatch(updateSuppliersInvoiceItem(id, inputValue, agataCode, agataPrice, unitPrice)).then((res) => {
      if (res.success) {
        setEdit(false);
      }
    });
  };

  const onCancel = () => {
    setInputValue(item.item_code_rivile);
    setAgataPrice(item.agata_price);
    setAgataCode(item.agata_code);
    setUnitPrice(item.unit_price);
    setEdit(false);
  };

  const onDelete = () => {
    if (window.confirm("Delete this invoice row?")) {
      dispatch(deleteSupplierInvoiceItem(id));
    }
  };

  const onRestore = () => {
    dispatch(restoreSupplierInvoiceItem(id));
  };

  const rowStyle = isDeleted
    ? { textDecoration: "line-through", opacity: 0.55 }
    : failedMatch ? { background: "#fbcfcf" } : {};

  return (
    <tr className="align-middle tableColumn" key={index} style={rowStyle}>
      <td className="align-middle">{item.number}</td>
      <td className="align-middle">
        {edit ? (
          <TextInputModal
            text=""
            placeholder="Enter"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
          />
        ) : item.item_code_rivile}
      </td>
      <td className="align-middle">{item.item_id}</td>
      <td className="align-middle">{item.item_model_name}</td>
      <td className="align-middle">{item.ean}</td>
      <td className="align-middle">{item.barcode}</td>
      <td className="align-middle">{item.description}</td>
      <td className="align-middle">{item.quantity}</td>
      <td className="align-middle">
        {edit ? (
          <TextInputModal
            text=""
            placeholder="Enter"
            value={unitPrice}
            onChange={(e) => setUnitPrice(e.target.value)}
          />
        ) : item.unit_price}
      </td>
      <td className="align-middle">
        {edit ? (
          <TextInputModal
            text=""
            placeholder="Enter"
            value={agataCode}
            onChange={(e) => setAgataCode(e.target.value)}
          />
        ) : item.agata_code}
      </td>
      <td className="align-middle">
        {edit ? (
          <TextInputModal
            text=""
            placeholder="Enter"
            value={agataPrice}
            onChange={(e) => setAgataPrice(e.target.value)}
          />
        ) : item.agata_price}
      </td>
      <td className="align-middle">{item.amount}</td>
      <td className="align-middle">
        <div className="d-flex align-items-center" style={{ gap: "6px" }}>
          {isDeleted ? (
            <FaUndo
              className="text-success"
              size={16}
              title="Restore row"
              style={{ cursor: "pointer" }}
              onClick={onRestore}
            />
          ) : edit ? (
            <>
              <FaCheck
                className="text-success"
                size={18}
                title="Save"
                style={{ cursor: "pointer" }}
                onClick={onSubmit}
              />
              <FaTimes
                className="text-danger"
                size={18}
                title="Cancel"
                style={{ cursor: "pointer" }}
                onClick={onCancel}
              />
            </>
          ) : (
            <>
              <MdEdit
                className="text-warning"
                size={20}
                title="Edit"
                style={{ cursor: "pointer" }}
                onClick={onEdit}
              />
              <FaTrash
                className="text-danger"
                size={15}
                title="Delete row"
                style={{ cursor: "pointer" }}
                onClick={onDelete}
              />
            </>
          )}
        </div>
      </td>
    </tr>
  );
}

export default TableItem;